// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:51:12

export default {
  "id": "geometry-vibes-x-ball",
  "slug": "geometry-vibes-x-ball",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b94a8549d5b5405eb640d0b242638055-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b94a8549d5b5405eb640d0b242638055/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Geometry Vibes X-Ball",
      "description": "Geometry Vibes X-Ball is ready to give you a completely different gaming experience! After the first game of the series, interactive new levels, challenge section and completely new store are waiting for you in X-Ball mode. \n\nStart your new adventure now in Geometry Vibes X-Ball game where you will find yourself avoiding obstacles, traps and gears in each level!",
      "instructions": "Click to \"MOUSE LEFT-CLICK\" or \"UP ARROW\" and hold to fly up. Release the button to dive down. In 2,3,4 Player game modes, other players are controlled with \"UP ARROW\", \"H\" and \"L\".\n",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "2players",
        "3players",
        "arcade",
        "ball",
        "geometry"
      ]
    },
    "zh-CN": {
      "title": "几何旋律 X-Ball",
      "description": "《几何节奏X球》准备为你带来完全不同的游戏体验！在系列的第一次游戏之后，互动新关卡、挑战区域以及全新的商店都在X球模式中等待着您。\n\n现在就开始在《几何节奏X球》游戏中的新冒险吧，在这里，您将发现自己需要在每个关卡中避开障碍、陷阱和齿轮！",
      "instructions": "点击“鼠标左键”或“上箭头”并保持以向上飞行。松开按钮以向下俯冲。在2、3、4人游戏模式中，其他玩家使用“上箭头”、“H”和“L”进行控制。",
      "genres": [
        "冒险"
      ],
      "tags": [
        "2人",
        "3人",
        "街机",
        "球",
        "几何"
      ]
    },
    "zh-TW": {
      "title": "幾何節奏X球",
      "description": "幾何節奏X-Ball準備好給你一個截然不同的遊戲體驗！在系列的第一次遊戲之後，互動新關卡、挑戰區域和全新的商店都等待著你在X-Ball模式中探索。\n\n現在就在幾何節奏X-Ball遊戲中啟動你的新冒險，在每個關卡中你將發現自己必須避開障礙、陷阱和機關！",
      "instructions": "點擊以「左鍵點擊」或「上箭頭」並按住以飛升。釋放按鈕以潛入。在2,3,4人遊戲模式中，其他玩家使用「上箭頭」、「H」和「L」控制。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "雙人玩家",
        "三人玩家",
        "街機",
        "球體",
        "幾何學"
      ]
    },
    "zh-HK": {
      "title": "幾何樂章 X-Ball",
      "description": "幾何韻律X-Ball準備好帶你進入一個完全不同的遊戲體驗！在系列作的第一部之後，互動新關卡、挑戰區和全新商店都等著你在X-Ball模式中探索。\n\n現在就開啟你的新冒險，在幾何韻律X-Ball遊戲中，你將會在每個關卡中避開障礙、陷阱和機械！",
      "instructions": "按「MOUSE 左鍵」或「上箭頭」飛昇，放開按鍵即跳下降。在 2、3、4 人遊戲模式中，其他玩家可使用「上箭頭」、「H」及「L」操控。",
      "genres": [
        "冒險"
      ],
      "tags": [
        "2人",
        "3人",
        "街機",
        "波",
        "幾何"
      ]
    },
    "ja": {
      "title": "幾何ビブズ エックスボール",
      "description": "ジオメトリ・ビブズ・エックスボールが、全く異なるゲーム体験をお届け準備です！シリーズの最初のゲーム以降、インタラクティブな新しいレベル、チャレンジセクション、そして全く新しいストアがX-Ballモードで待っています。\n\nジオメトリ・ビブズ・エックスボールゲームで今すぐ新しい冒険を始め、各レベルで障害物、罠、機構を避けることになります！",
      "instructions": "「MOUSE LEFT-CLICK」または「UP ARROW」をクリックして上昇するために長押ししてください。ボタンを離すと急降下します。2、3、4プレイヤーゲームモードでは、他のプレイヤーは「UP ARROW」、「H」および「L」で操作されます。",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "2人用",
        "3人用",
        "アーケード",
        "ボール",
        "幾何学"
      ]
    },
    "ko": {
      "title": "지오메트리 빅스 엑스볼",
      "description": "지오메트리 비브스 X-Ball이 완전히 다른 게임 경험을 제공할 준비가 되었습니다! 시리즈의 첫 번째 게임 이후, 상호작용적인 새로운 레벨, 도전 부문 그리고 완전히 새로운 상점이 X-Ball 모드에서 기다리고 있습니다.\n\n지오메트리 비브스 X-Ball 게임에서 새로운 모험을 시작해보세요. 각 레벨마다 장애물, 트랩, 기계를 피해야 합니다!",
      "instructions": "\"MOUSE LEFT-CLICK\" 또는 \"UP ARROW\"을 클릭하여 상승하는 것을 유지하세요. 버튼을 떼면 하강합니다. 2, 3, 4 플레이어 모드에서는 다른 플레이어를 \"UP ARROW\", \"H\" 및 \"L\"로 제어합니다.",
      "genres": [
        "모험"
      ],
      "tags": [
        "2인",
        "3인",
        "아케이드",
        "볼",
        "기하학"
      ]
    },
    "fr": {
      "title": "Géométrie Vibrations X-Ball",
      "description": "Geometry Vibes X-Ball est prêt à vous offrir une expérience de jeu complètement différente ! Après le premier jeu de la série, des niveaux interactifs nouveaux, une section de défis et un magasin complètement nouveau vous attendent dans le mode X-Ball.\n\nCommencez votre nouvelle aventure dès maintenant dans le jeu Geometry Vibes X-Ball où vous devrez éviter les obstacles, les pièges et les engrenages à chaque niveau !",
      "instructions": "Cliquez sur \"MOUSE GAUCHE\" ou \"FLÈCHE DU HAUT\" et tenez pour monter. Relâchez le bouton pour plonger. Dans les modes de jeu 2, 3 et 4 joueurs, les autres joueurs sont contrôlés avec \"FLÈCHE DU HAUT\", \"H\" et \"L\".",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "2 joueurs",
        "3 joueurs",
        "arcade",
        "balle",
        "géométrie"
      ]
    }
  }
};
